import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { BASE_COLORS } from "../../utils/colors";
import { Box } from "@mui/material";

// Label rendering
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      fontSize="12"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const ReusablePieChart = ({ title, data }) => {
  if (!data || data.length === 0) return null;

  const maxVal = Math.max(...data.map((d) => d.value));
  const maxIndices = data
    .map((d, i) => (d.value === maxVal ? i : -1))
    .filter((i) => i !== -1);
  const primaryIndex = maxIndices[0];

  const COLORS = data.map((_, i) =>
    i === primaryIndex
      ? BASE_COLORS[0]
      : BASE_COLORS[(i + 1) % BASE_COLORS.length]
  );

  return (
    <Box sx={{ width: "100%", aspectRatio: "1 / 1" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
          width={"100%"}
          height={"100%"}
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius="80%"
            label={renderCustomizedLabel}
            labelLine={false}
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default ReusablePieChart;
